import React, { Fragment } from 'react';

import HomeLayout from '../components/layout/HomeLayout';

function Home(props) {
  return <HomeLayout />;
}

export default Home;
